import { render } from "./TransferForm.vue?vue&type=template&id=57c122fa&scoped=true"
import script from "./TransferForm.vue?vue&type=script&lang=js"
export * from "./TransferForm.vue?vue&type=script&lang=js"

import "./TransferForm.vue?vue&type=style&index=0&id=57c122fa&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57c122fa"]])

export default __exports__